<template>
  <div id="index">
    <el-container>
      <div class="rightSide">
        <el-header class="Large-Header">
          <img src="~/assets/img/Loginlogo.png" />
          <span>
            Air Compressor IoT Management Platform
            <small>Installation</small>
          </span>
        </el-header>
        <el-main class="index Large-index">
          <el-row>
            <el-col :xs="24" :sm="24" :md="24" :lg="24">
              <div class="homeCon">
                <el-row>
                  <el-col :xs="12" :sm="12" :md="12" :lg="6">
                    <div class="mapNum">
                      <img src="~assets/img/icon_Shipped.png" />
                      <div style="display: inline-block">
                        <h4 class="BoxTitle">Total shipment</h4>
                        <strong class="BoxNum"> 15254 </strong>
                      </div>
                    </div>
                  </el-col>
                  <el-col :xs="12" :sm="12" :md="12" :lg="6">
                    <div class="mapNum">
                      <img src="~assets/img/icon_Registered.png" />
                      <div style="display: inline-block">
                        <h4 class="BoxTitle">Total registration</h4>
                        <strong class="BoxNum"> 15194 </strong>
                      </div>
                    </div>
                  </el-col>
                  <el-col :xs="12" :sm="12" :md="12" :lg="6">
                    <div class="mapNum">
                      <img src="~assets/img/icon_Connected_Active.png" />
                      <div style="display: inline-block">
                        <h4 class="BoxTitle">Total online</h4>
                        <strong class="BoxNum"> 15140 </strong>
                      </div>
                    </div>
                  </el-col>
                  <el-col :xs="12" :sm="12" :md="12" :lg="6">
                    <div class="mapNum">
                      <img src="~assets/img/icon_Connected_Offline.png" />
                      <div style="display: inline-block">
                        <h4 class="BoxTitle">Total offline</h4>
                        <strong class="BoxNum"> 54 </strong>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="6" :lg="6">
              <div class="KPIDiv">
                <div class="block homeCon">
                  <div class="LeftB" style="border-left-color: #055076">
                    <h4>Rotary China shipment</h4>
                    <span>5891<small>台</small></span>
                  </div>

                  <div class="divide"></div>

                  <div class="LeftB" style="border-left-color: #1c6c98">
                    <h4>Rotary RoaAP shipment</h4>
                    <span>3856<small>台</small></span>
                  </div>
                </div>
              </div>
              <div class="KPIDiv">
                <div class="block homeCon">
                  <div class="LeftB" style="border-left-color: #3e90bf">
                    <h4>PAC China shipment</h4>
                    <span>1856<small>台</small></span>
                  </div>

                  <div class="divide"></div>

                  <div class="LeftB" style="border-left-color: #5fa2c6">
                    <h4>PAC RoaAP shipment</h4>
                    <span>845<small>台</small></span>
                  </div>
                </div>
              </div>
              <div class="KPIDiv">
                <div class="block homeCon">
                  <div class="LeftB" style="border-left-color: #81c9f0">
                    <h4>BV China shipment</h4>
                    <span>0<small>台</small></span>
                  </div>

                  <div class="divide"></div>

                  <div class="LeftB" style="border-left-color: #a2e0ff">
                    <h4>BV RoaAP shipment</h4>
                    <span>0<small>台</small></span>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="9" :lg="9">
              <div class="KPIDiv">
                <div class="block homeCon">
                  <div class="LeftB" style="border: 0; padding-left: 0">
                    <h4>Rotary China/RoAP registration</h4>
                    <div
                      id="RegistLineRotary"
                      style="width: 100%; height: 139px"
                    ></div>
                  </div>
                </div>
                <div class="block homeCon">
                  <div class="LeftB" style="border: 0; padding-left: 0">
                    <h4>PAC China/RoAP registration</h4>
                    <div
                      id="RegistLinePAC"
                      style="width: 100%; height: 139px"
                    ></div>
                  </div>
                </div>
                <div class="block homeCon">
                  <div class="LeftB" style="border: 0; padding-left: 0">
                    <h4>BV China/RoAP registration</h4>
                    <div
                      id="RegistLineBV"
                      style="width: 100%; height: 139px"
                    ></div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="9" :lg="9">
              <div class="homeCon">
                <h4 class="BoxTitle">
                  Online <strong class="fr">76.45%</strong>
                </h4>
                <div id="onlineBar" style="width: 100%; height: 267px"></div>
                <ul class="InstallTotal">
                  <li v-for="item in onlineTotal">
                    <span class="name">{{ item.name }}</span>
                    <span class="num"
                      >{{ item.num }}<small>/</small> {{ item.rate }}%</span
                    >
                  </li>
                </ul>
              </div>
              <div class="homeCon">
                <h4 class="BoxTitle">
                  Offline <strong class="fr">76.45%</strong>
                </h4>
                <div id="offlineBar" style="width: 100%; height: 267px"></div>
                <ul class="InstallTotal">
                  <li v-for="item in offlineTotal">
                    <span class="name">{{ item.name }}</span>
                    <span class="num"
                      >{{ item.num }}<small>/</small> {{ item.rate }}%</span
                    >
                  </li>
                </ul>
              </div>
            </el-col>
          </el-row>
        </el-main>
      </div>
    </el-container>
  </div>
</template>

  <script type="text/javascript">
import * as echarts from "echarts";
import "assets/eCharts/world_new.js";

export default {
  name: "Index",
  data() {
    return {
      registTotal: [
        {
          name: "Rotary China",
          num: 1524,
          value: [50, 45, 50, 40, 50, 60, 70, 60, 70],
        },
        {
          name: "Rotary RoAP",
          num: 412,
          value: [60, 65, 70, 65, 60, 50, 45, 45, 40],
        },
        {
          name: "PAC China",
          num: 258,
          value: [57, 58, 58, 52, 45, 45, 48, 57, 54],
        },
        {
          name: "PAC RoAP",
          num: 56,
          value: [42, 48, 49, 45, 41, 47, 45, 42, 40],
        },
        {
          name: "BV China",
          num: 0,
          value: [25, 35, 37, 35, 29, 24, 25, 34, 29],
        },
        { name: "BV RoAP", num: 0, value: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0] },
      ],
      onlineTotal: [
        { name: "Rotary China", num: 1475, rate: 90.47 },
        { name: "Rotary RoAP", num: 386, rate: 84.12 },
        { name: "PAC China", num: 258, rate: 100 },
        { name: "PAC RoAP", num: 42, rate: 75 },
        { name: "BV China", num: 0, rate: 0 },
        { name: "BV RoAP", num: 0, rate: 0 },
      ],
      offlineTotal: [
        { name: "Rotary China", num: 125, rate: 9.85 },
        { name: "Rotary RoAP", num: 35, rate: 24 },
        { name: "PAC China", num: 0, rate: 0 },
        { name: "PAC RoAP", num: 12, rate: 21.52 },
        { name: "BV China", num: 0, rate: 0 },
        { name: "BV RoAP", num: 0, rate: 0 },
      ],
    };
  },
  created: function () {
    var that = this;
    this.$nextTick(() => {
      that.initRegistLine("RegistLineRotary", "Rotary");
      that.initRegistLine("RegistLinePAC", "PAC");
      that.initRegistLine("RegistLineBV", "BV");
      that.initBar("onlineBar", "Total online", that.onlineTotal);
      that.initBar("offlineBar", "Total offline", that.offlineTotal);
    });
  },
  methods: {
    initRegistLine(id, type) {
      var color = [
        "84,112,198",
        "145,204,117",
        "103,131,250",
        "80,185,118",
        "115,192,222",
        "59,162,114",
      ];
      var timeLine = [
        "8-19",
        "8-18",
        "8-17",
        "8-16",
        "8-15",
        "8-14",
        "8-13",
        "8-12",
        "8-11",
      ];
      var series = [];
      for (var i = 0; i < this.registTotal.length; i++) {
        if (this.registTotal[i].name.includes(type)) {
          series.push({
            name: this.registTotal[i].name,
            type: "line",
            smooth: true, //是否平滑
            showSymbol: false,
            symbolSize: 8,
            lineStyle: {
              normal: {
                color: "rgb(" + color[i] + ")",
              },
            },
            itemStyle: {
              // color: "#28739A",
              // borderColor: "#28739A",
              // borderWidth: 2,
            },
            emphasis: {
              focus: "series",
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(" + color[i] + ",0.7)" },
                  { offset: 0.35, color: "rgba(" + color[i] + ",0.4)" },
                  { offset: 1, color: "rgba(" + color[i] + ",0)" },
                ]),
              },
            },
            endLabel: {
              show: true,
              formatter: function (params) {
                return params.value + "%  " + params.seriesName;
              },
              color: "#fff",
              fontSize: 12,
            },
            data: this.registTotal[i].value,
          });
        }
      }
      // 获取echarts的容器
      var chart = echarts.init(document.getElementById(id));
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "line", // 默认为直线，可选为：'line' | 'shadow'
          },
          position: "top",
          backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
          borderColor: "rgba(0,0,0,0)",
          textStyle: {
            color: "#fff",
            fontSize: 12,
            fontFamily: "Arial",
          },
        },
        grid: {
          left: 0,
          right: 120,
          bottom: 0,
          top: 0,
        },
        xAxis: {
          type: "category",
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          boundaryGap: false,
          data: timeLine,
        },
        yAxis: {
          max: 100,
          type: "value",
          splitNumber: 5,
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        series: series,
      };
      chart.setOption(option);

      window.addEventListener("resize", () => {
        chart.resize();
      });
    },
    initBar(id, name, data) {
      var that = this;
      var RateData = [];
      var nameDate = [];
      for (let i = 0; i < data.length; i++) {
        nameDate.push(data[i].name);
        RateData.push(data[i].rate);
      }

      // 获取echarts的容器
      var chart = echarts.init(document.getElementById(id));
      var option = {
        grid: {
          left: 0,
          right: 0,
          bottom: -10,
          top: 0,
        },
        xAxis: {
          type: "value",
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        yAxis: {
          type: "category",
          inverse: true,
          data: nameDate,
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            name: name,
            type: "bar",
            barCategoryGap: "40%",
            data: RateData,
            showBackground: true,
            backgroundStyle: {
              color: "#30333B",
            },
            itemStyle: {
              borderRadius: [0, 10, 10, 0],
              color: new echarts.graphic.LinearGradient(0, 1, 1, 0, [
                { offset: 0, color: "#00759B" },
                { offset: 1, color: "#1A3B46" },
              ]),
            },
          },
        ],
      };
      chart.setOption(option);

      window.addEventListener("resize", () => {
        chart.resize();
      });
    },
  },
};
</script>

<style lang='less' scope>
body {
  padding: 0;
  margin: 0;
  color: #fff;
}
.theme1 {
  .KPIDiv {
    .block {
      padding: 20px;
      .LeftB {
        margin-bottom: 0;
        height: auto;
      }
    }
    .divide {
      margin: 19px 0 20px;
    }
  }

  .rightSide {
    top: 0;
    left: 0;
  }

  .Large-Header {
    text-align: center;
    height: 90px !important;
    z-index: 2;
    img {
      width: 140px;
      margin: 20px 0 0 30px;
      float: left;
    }
    span {
      display: inline-block;
      font-size: 24px;
      font-weight: 600;
      margin-top: 15px;
      line-height: 45px;
      margin-left: -140px;
      small {
        display: block;
        font-size: 16px;
        margin: 0;
        line-height: 16px;
        color: #828393;
      }
    }
  }
  .Large-index {
    padding-top: 90px !important;
  }
  // .el-row {
  //   margin-left: -10px !important;
  //   margin-right: -10px !important;
  // }
  // .el-col {
  //   padding-left: 10px !important;
  //   padding-right: 10px !important;
  // }

  .homeCon {
    padding: 12px 15px;
    //border-radius: 8px;
    // margin-bottom: 20px;
  }
  .InstallTotal {
    position: absolute;
    bottom: 2px;
    right: 15px;
    left: 15px;
    margin: 0;
    padding: 0;
    list-style: none;
    font-size: 12px;
    li {
      line-height: 15px;
      padding: 16px 10px 15px;
      span.name {
        display: inline-block;
        font-weight: bold;
        color: #fff;
        width: calc(100% - 120px);
      }
      span.num {
        display: inline-block;
        color: #fff;
        width: 120px;
        text-align: right;
        small {
          font-size: 12px;
          color: rgba(255, 255, 255, 0.5);
          margin: 0 5px;
        }
      }
    }
  }
}
</style>